import "./Txt2Img.css";
import React, { Component } from "react";
import ImageLoader from "./common/ImageLoader";
import { TextTutorial } from "./Tutorials";
import { FaQuestionCircle } from "react-icons/fa";

class Txt2Img extends Component {
    state = {
        showHelp: false,
    }

    render() {
        return (
            <div className="text-image-container">
                {!this.props.isViewer &&
                    <div style={{ color: "white", textAlign: "center", fontSize: "10pt", margin: "5px" }}>
                        {"Text to Image "}
                        <FaQuestionCircle size={15} onClick={() => this.setState({ showHelp: true })} style={{ verticalAlign: "middle", cursor: "pointer" }} />
                    </div>
                }
                {this.state.showHelp &&
                    <TextTutorial close={() => { this.setState({ showHelp: false }) }} />
                }
                {this.props.loading
                    ? <ImageLoader />
                    : null
                }

                <img
                    src={this.props.latestImageURL}
                    alt="GeneratedImage"
                    className="text-generator-image"
                />
            </div>

        );
    }
}

export default Txt2Img;